import { useState, useCallback } from "react";

const STORAGE_KEY = "panel-visibility";

const DEFAULT_VISIBLE = new Set([
  "status", "tactical", "comms",
]);

function loadVisibility(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return new Set(JSON.parse(raw) as string[]);
  } catch {}
  return new Set(DEFAULT_VISIBLE);
}

function saveVisibility(visible: Set<string>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...visible]));
  } catch {}
}

export function usePanelManager() {
  const [visible, setVisible] = useState<Set<string>>(loadVisibility);
  const [layoutKey, setLayoutKey] = useState(0);

  const toggle = useCallback((id: string) => {
    setVisible(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      saveVisibility(next);
      return next;
    });
  }, []);

  const resetLayout = useCallback(() => {
    // Clear all panel position and size entries
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith("panel-pos:") || key.startsWith("panel-size:"))) {
        keys.push(key);
      }
    }
    keys.forEach(k => localStorage.removeItem(k));

    // Reset visibility
    setVisible(new Set(DEFAULT_VISIBLE));
    saveVisibility(DEFAULT_VISIBLE);

    // Increment key to force re-mount of all panels
    setLayoutKey(k => k + 1);
  }, []);

  return { visible, toggle, resetLayout, layoutKey };
}
